<template>
    <v-flex xl12>
        <h2>Banners<span class="text-title-header"> | Cadastro de banners</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'banners',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
